const formatCodeString = (originalString) => {
    const lines = originalString.split('\n');
    const trimmedLines = lines.map(line => line.trim());
    const nonEmptyLines = trimmedLines.filter(line => line !== '');
    const formattedString = `${nonEmptyLines.map(line => `${line}`).join('\n')}`;
    return formattedString;
  }

export default formatCodeString;